<template>
    <el-collapse v-model="params.names">
        <el-collapse-item :name="i" v-for="(item,i) in params.identified_user_rules" :key="i">
            <template slot="title">
                <div  class="flex title-change-btn">
                    <div>
                        年龄：
                        <span>{{item.age_from}}</span>岁
                        <span style="margin: 0 8px">至</span>
                        <span>{{item.age_to === 150 ? '26岁及以上' : item.age_to + '岁'}}</span>
                    </div>
                </div>
            </template>
            <div class="border-card mar-t-0">
                <template v-if="item.limit_type.indexOf(1) > -1">
                    <el-form-item label="节假日登录限制：" class="greenitem"></el-form-item>
                    <el-form-item v-for="(timeRange,timeIndex) in item.login_rule.holiday.rules" :key="'timeRange'+ timeIndex"
                                  :label="randerLabel(timeRange.date_type)"
                                  label-width="140px">
                        <template v-if="timeRange.date_type === 1">
                            当天累计登陆上限
                            <span>{{timeRange.daily_max_game_time}}</span>
                            min
                        </template>
                        <template v-else-if="timeRange.date_type === 2">
                            <span>{{timeRange.start_time}}</span>
                            <span style="margin: 0 8px">至</span>
                            <span>{{timeRange.end_time}}</span>
                        </template>

                        <template v-else-if="timeRange.date_type === 3">
                            <span>{{timeRange.start_time}}</span>
                            <span style="margin: 0 8px">至</span>
                            <span>{{timeRange.end_time}}</span>
                        </template>

                    </el-form-item>

                    <el-form-item label="非节假日（周五）登录限制：" class="greenitem"></el-form-item>
                    <el-form-item v-for="(timeRangeSpecial,timeIndex) in item.login_rule.work_day_special.rules"
                                  :key="'timeRangeSpecial'+ timeIndex"
                                  :label="randerLabel(timeRangeSpecial.date_type)"
                                  label-width="140px">
                        <template v-if="timeRangeSpecial.date_type === 1">
                            当天累计登陆上限
                            <span>{{timeRangeSpecial.daily_max_game_time}}</span>
                            min
                        </template>
                        <template v-else-if="timeRangeSpecial.date_type === 2">
                            <span>{{timeRangeSpecial.start_time}}</span>
                            <span style="margin: 0 8px">至</span>
                            <span>{{timeRangeSpecial.end_time}}</span>
                        </template>

                        <template v-else-if="timeRangeSpecial.date_type === 3">
                            <span>{{timeRangeSpecial.start_time}}</span>
                            <span style="margin: 0 8px">至</span>
                            <span>{{timeRangeSpecial.end_time}}</span>
                        </template>

                    </el-form-item>

                    <el-form-item label="非节假日（非周五）登录限制：" class="greenitem"></el-form-item>
                    <el-form-item v-for="(timeRangeNormal,timeIndex) in item.login_rule.work_day_normal.rules"
                                  :key="'timeRangeNormal'+ timeIndex"
                                  :label="randerLabel(timeRangeNormal.date_type)"
                                  label-width="140px">
                        <template v-if="timeRangeNormal.date_type === 1">
                            当天累计登陆上限
                            <span>{{timeRangeNormal.daily_max_game_time}}</span>
                            min
                        </template>
                        <template v-else-if="timeRangeNormal.date_type === 2">
                            <span>{{timeRangeNormal.start_time}}</span>
                            <span style="margin: 0 8px">至</span>
                            <span>{{timeRangeNormal.end_time}}</span>
                        </template>

                        <template v-else-if="timeRangeNormal.date_type === 3">
                            <span>{{timeRangeNormal.start_time}}</span>
                            <span style="margin: 0 8px">至</span>
                            <span>{{timeRangeNormal.end_time}}</span>
                        </template>

                    </el-form-item>
                </template>
                <template v-if="item.limit_type.indexOf(2) > -1">
                    <el-form-item label="消费限制：" class="greenitem"></el-form-item>
                    <el-form-item label="单笔单次消费上限金额：">
                        <span>{{item.payment_rule.max_consume_per_order}}</span> RMB
                    </el-form-item>
                    <el-form-item label="单月累计消费上限金额：">
                        <span>{{item.payment_rule.max_consume_per_month}}</span> RMB
                    </el-form-item>
                </template>
            </div>
        </el-collapse-item>
    </el-collapse>
</template>

<script>
export default {
    name: "identified",
    props: {
        params:{
            type: Object,
            default: () => {}
        }
    },
    methods: {
        randerLabel(type) {
            switch (type) {
                case 1:
                    return '累计可玩时长：'
                case 2:
                    return '指定时间不可登陆：'
                case 3:
                    return '指定时间可登陆：'
            }
        }
    }
}
</script>

<style lang="scss">
    .greenitem .el-form-item__label  {
        color: green;
    }
</style>



// WEBPACK FOOTER //
// website/subComponents/antiAddiction/identified.vue